export default __webpack_public_path__ + "static/media/img8.56fc9f95.jpeg";